// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"18":"product","119":"store","325":"product-edit","787":"store-edit"}[chunkId] + "." + {"18":"ec3f9dc8","119":"04a233a2","325":"0a619990","787":"70da2e49"}[chunkId] + ".css";
};